/**
 * Created by nijin on 16/2/17.
 */
/**
 * Created by nijin on 16/2/17.
 */
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nuc-app-automotive',
  templateUrl: './automotive.html'
})
export class AutoMotiveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/site/use-cases/automotive/automotive.ts